import { Loadable, LoadableState, OrderExchangeCondition } from '@eih-netbroker/common';
import { ReactComponent as CheckIcon } from '../../../../../assets/icons/checkbox-circle-fill.svg';
import { ReactComponent as ErrorIcon } from '../../../../../assets/icons/errorcircle.svg';
import { useLocale } from '../../../../../context/NbLocalizationContext';
import { NbLoader } from '../../../../../shared/components/loader/Loader';
import classes from './ConditionsTooltip.module.scss';

type ConditionsTooltipProps = {
  conditions: LoadableState<OrderExchangeCondition[]>;
};

export const ConditionsTooltip = ({ conditions }: ConditionsTooltipProps) => {
  const { translation } = useLocale();
  const t = translation.orderModal.currencyExchangeForm.conditionsTooltip;

  if (!Loadable.hasValue(conditions)) {
    return (
      <NbLoader
        horizontalCenter
        verticalCenter
        size="small"
      />
    );
  }

  return (
    <div className={classes.container}>
      <span className={classes.title}>{t.title}</span>
      {conditions.map(condition => {
        return (
          <div
            key={condition.id}
            className={classes.conditionItem}
          >
            {condition.isSatisfied ? (
              <CheckIcon className={`${classes.icon} ${classes.iconSatisfied}`} />
            ) : (
              <ErrorIcon className={`${classes.icon} ${classes.iconUnsatisfied}`} />
            )}
            <span
              className={`${classes.label} ${
                condition.isSatisfied ? classes.labelSatisfied : classes.labelUnsatisfied
              }`}
            >
              {t.conditions[condition.id]}
            </span>
          </div>
        );
      })}
    </div>
  );
};
